import { useTranslation } from "react-i18next";
import ContainerLayout from "../../../components/container-layout/ContainerLayout";
import StateComponents from "../../../components/state-component/StateComponents";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import StepperCustom from "../../../components/step/Stepper";
import { useCallback, useEffect, useRef, useState } from "react";
import { Box, Divider, MenuItem, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ButtonContained, ButtonOutlined } from "../../../components/button/ButtonCustoms";
import ContainerButton from "../../../components/button/ContainerButton";
import { EvidencePayment, FileApplicant, FormApplicant } from "../list-applicants/applicent-detail";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import FilterSelect from "../../../components/select/filterSelect";
import { ReactComponent as Bag } from '../../../assets/icons/bag-button.svg'
import { ReactComponent as Document } from '../../../assets/icons/document.svg'
import UploadFile from "../../../components/upload/UploadFile";
import { StudentApi } from "../../../api/student/student.api";
import StatusCustom from "../../../components/status/statusCustom";
import { renderStatus } from "../history-online-Admission/enum/admission.enum";
import { alertActive, alertError, alertSuccess, swalError } from "../../../components/alert/swal";
import { unsetLoading } from "../../../store/loading/loading.slice";
import { useDispatch } from "react-redux";
import ModalCustom from "../../../components/modal/ModalCustom";
import { dateToView, timeToView } from "../../../utils/date.utils";
import moment from "moment";
export default function StudentRegistrationInformationDetail(props: any) {
  const { t } = useTranslation();
  const { id } = useParams();
  const { view } = props
  const dispatch = useDispatch();

  const [tabStep, setTebStep] = useState(0);
  const [form, setForm] = useState<any>();

  const allStep = [
    {
      name: "ข้อมูลส่วนบุคคลผู้สมัคร",
      isAccept: false,
      icon: null
    },
    {
      name: "หลักฐานการจ่ายค่าสมัคร",
      isAccept: false,
      icon: null
    },
    {
      name: "ข้อมูลการขึ้นทะเบียน",
      isAccept: false,
      icon: null
    },
    {
      name: "ประวัติการศึกษา",
      isAccept: false,
      icon: null
    },

    {
      name: "ใบรับรอง",
      isAccept: false,
      icon: null
    },
    {
      name: "ข้อมูลวีซ่า",
      isAccept: false,
      icon: null
    },
    {
      name: "ค่าเทอม",
      isAccept: false,
      icon: null
    },

  ];
  const getStudent = async () => {
    const res = await StudentApi.getStudent(Number(id));
    const data = res.data;
    if (data.status < 300) {
      setForm({
        ...data.data,

        first_name: data.data.student_frist_name,
        middle_name: data.data.student_middle_name,
        last_name: data.data.student_last_name,
        nickname: data.data.student_nickname,
        // email: data.data.student_email,

        admission_student_address: data.data.student_address,
        admission_student_parent: {
          ...data.data.student_parent
        },
        admission_student_files: data.data.student_files
      })
      // setForm(res.data.data)
    }
  };

  useEffect(() => {
    if (id) {
      getStudent();
    }
  }, []);

  const handleStatus = async (status: string) => {
    const body = { student_status: status }
    await StudentApi.patchStatus(Number(id), body)
      .then((res) => {
        if (res.status < 300) {
          alertSuccess("อัพเดทสถานะ", "อัพเดทสถานะ เรียบร้อย");
          getStudent()
        }
      })
      .catch((err) => {
        console.log(err);
        alertError("อัพเดทสถานะ", "อัพเดทสถานะ ไม่สำเร็จ");
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  }
  return (
    <div className='w-full'>
      <ContainerLayout
        title={t("ข้อมูลส่วนบุคคลผู้สมัคร")}
        // hidden_sub_title
        navigateContent={
          <NavigateListCustom
            navigateData={[
              {
                key: "complaintSubmit",
                name: t("ข้อมูลทะเบียนนักศึกษา"),
                disabled_match: true,
                pathName: routeName.admission.student_registration_information
              },

              {
                key: "complaintSubmit",
                name: t("ข้อมูลส่วนบุคคลนักศึกษา"),
                pathName: routeName.admission.student_registration_information_detail.replace(':id', `${id}`)
              },
            ]}
          />
        }
        buttonContent={

          <div>
            <FilterSelect
              style={{ padding: 0, width: "200px" }}
              onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleStatus(e.target.value)
              }}
              value={form?.student_status || ''}
              labelId={"1"}
              selectId={"1"}
              // disabled={}
              heading="สถานะนักศึกษา"
              options={[{ label: 'กำลังศึกษา', value: 'STUDYING' },
              { label: 'จบการศึกษา', value: 'FINISH_STUDYING' },
              { label: 'พ้นสภาพ', value: 'NO_LONGER_STUDENT' },
              { label: 'ลาออก', value: 'RESIGN' },
              { label: 'พักการเรียน', value: 'STUDENT_SUSPENSION' },].map((x) => {
                return (
                  <MenuItem value={x?.value}>
                    {x?.label}
                  </MenuItem>
                )
              })}
            /></div>
        }
        content={
          <div className='w-full'>
            <section
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "24px",
              }}
            >
              <StepperCustom
                step={tabStep}
                setStep={setTebStep}
                stepLabel={allStep}
                view={true}
              />
            </section>
            {tabStep === 0 &&
              <div style={{ display: 'flex', flexDirection: 'column', gap: "20px" }}>
                <FormApplicant form={form} />
                <FileApplicant form={form} />

              </div>
            }
            {tabStep === 1 &&
              <>
                <EvidencePayment form={form?.admission_student} />
              </>
            }
            {tabStep === 2 &&
              <>
                <StateComponents
                  otherProps={{ spacing: 2 }}
                  typeProps={[
                    {
                      seq: 1,
                      type: "SELECT",
                      gridProps: {
                        xs: 12,
                        md: 2
                      },
                      fieldProps: {
                        labelId: "ss",
                        heading: "ระดับ",
                        onChange: (e) => {
                          // handleChange('form_type', index, e.target.value);
                        },
                        options: [
                          {
                            value: form?.degree?.id_degree,
                            label: form?.degree?.degree_name,
                          },
                        ],
                        selectId: "",
                        value: form?.id_degree || '',
                        disabled: true
                      }
                    },
                    {
                      seq: 2,
                      type: "SELECT",
                      gridProps: {
                        xs: 12,
                        md: 4
                      },
                      fieldProps: {
                        labelId: "ss",
                        heading: "หลักสูตร",
                        onChange: (e) => {
                          // handleChange('form_type', index, e.target.value);
                        },
                        options: [
                          {
                            value: form?.faculty?.id_faculty,
                            label: form?.faculty?.faculty_name,
                          },
                        ],
                        selectId: "",
                        value: form?.id_faculty || '',
                        disabled: true
                      }
                    },
                    {
                      seq: 3,
                      type: "TEXT_FIELD",
                      gridProps: {
                        xs: 12,
                        md: 2
                      },
                      fieldProps: {
                        heading: "ชั้นปีที่",
                        onChange: (e) => { },
                        value: form?.term,
                        disabled: true
                      }
                    },
                    {
                      seq: 4,
                      type: "TEXT_FIELD",
                      gridProps: {
                        xs: 12,
                        md: 2
                      },
                      fieldProps: {
                        heading: "ห้อง",
                        onChange: (e) => { },
                        value: form?.room,
                        disabled: true
                      }
                    },
                    {
                      seq: 5,
                      type: "TEXT_FIELD",
                      gridProps: {
                        xs: 12,
                        md: 2
                      },
                      fieldProps: {
                        heading: "อีเมลผู้ใช้ ปัจจุบัน",
                        onChange: (e) => { },
                        value: form?.email,
                        disabled: true
                      }
                    },
                    {
                      seq: 6,
                      type: "SELECT",
                      gridProps: {
                        xs: 12,
                        md: 2
                      },
                      fieldProps: {
                        labelId: "ss",
                        heading: "ปีที่เข้ารับการศึกษา",
                        onChange: (e) => {
                          // handleChange('form_type', index, e.target.value);
                        },
                        options: [
                          {
                            label: moment(form?.date_first_studies).add(543, 'year').format('YYYY'),
                            value: moment(form?.date_first_studies).add(543, 'year').format('YYYY'),
                          },

                        ],
                        selectId: "",
                        value: moment(form?.date_first_studies).add(543, 'year').format('YYYY'),
                        disabled: true
                      }
                    },
                    {
                      seq: 7,
                      type: "DATE",
                      gridProps: {
                        xs: 12,
                        md: 4
                      },
                      fieldProps: {
                        onChange: (e) => { },
                        heading: 'วันที่เริ่มเข้ารับการศึกษา',
                        placeholder: 'วันที่เริ่มเข้ารับการศึกษา',
                        allowClear: true,
                        onClear: () => {

                        },
                        value: form?.date_first_studies,
                        disabled: true
                      },
                    },
                    {
                      seq: 8,
                      type: "TEXT_FIELD",
                      gridProps: {
                        xs: 12,
                        md: 2
                      },
                      fieldProps: {
                        heading: "รหัสประจำตัวนักศึกษา",
                        onChange: (e) => { },
                        value: form?.student_no,
                        disabled: true
                      }
                    },

                    {
                      seq: 9,
                      type: "TEXT_FIELD",
                      gridProps: {
                        xs: 12,
                        md: 4
                      },
                      fieldProps: {
                        heading: "อีเมลนักศึกษา",
                        onChange: (e) => { },
                        value: form?.student_email,
                        disabled: true
                      }
                    },

                  ]} />
              </>
            }
            {tabStep === 3 &&
              <EducationalRecord form={form} />
            }
            {tabStep === 4 &&
              <Certificate />
            }
            {tabStep === 5 &&
              <VisaInformation />
            }
            {tabStep === 6 &&
              <TermFees />
            }

          </div>
        }
      />

    </div>
  )
}
const Certificate = () => {
  const { id } = useParams()
  const fileRef = useRef<any>()
  const dispatch = useDispatch();

  const [detail, setDetail] = useState<any[]>([])
  const [pathUrl, setPathUrl] = useState<string>("");
  const [showModal, setShowModal] = useState<string>("");
  const [name, setName] = useState<string>('');
  const handleCloseModal = () => {
    setShowModal("");
    setName('')
  }
  const getDetail = async () => {
    await StudentApi.getCertificate(Number(id)).then((res) => {
      if (res.status < 300) {
        setDetail(res.data?.data.map((item: any) => {
          return {
            ...item,
            student_certificate_file: item?.student_certificate_file ? item?.student_certificate_file : {}
          }
        }));
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  useEffect(() => {
    if (id) {
      getDetail()
    }
  }, [])
  useEffect(() => {
    const init = async () => {
      const response = await fetch("/resources/config.json");
      const results = await response.json();
      setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
    };
    init();
  }, []);
  const onImageChange = async (event: any, indexItem: number) => {
    console.log(event);
    if (event && event[0]) {
      const formData = new FormData();

      //DRAFT
      formData.append('file', event[0]);

      await StudentApi.postCertificateFile(Number(id), formData).then((res: any) => {
        if (res.status < 300) {
          // setForm({ ...form, admission_student_file: form?.admission_student_file?.length > 0 ? [...form?.admission_student_file, { ...res.data.data, id_document: item?.id_document }] : [{ ...res.data.data, id_document: item?.id_document }] })
          // console.log(res.data);
          setDetail((prev: any) =>
            prev.map((item: any, index: number) =>
              index === indexItem
                ? {
                  ...item,
                  student_certificate_file: res.data.data
                }
                : item
            )
          );
          if (fileRef.current) {
            fileRef.current.value = null;
          }

          // swalSuccess('ยืนยันการชำระเงิน', 'ยืนยันการชำระเงิน เรียบร้อยแล้ว กรูณารอทางเจ้าหน้าที่ตรวจสอบ')
        }
      }).catch((error: any) => {
        console.log(error)
        if (fileRef.current) {
          fileRef.current.value = null;
        }
        swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
      })

    }
  }
  const handleSubmit = async () => {
    const body = detail?.map((item: any) => {
      return {
        "id_student_certificate": item?.id_student_certificate,
        "certificate_name": item?.certificate_name,
        "id_student_certificate_file": item?.student_certificate_file?.id_student_certificate_file,
        "status": "active"
      }
    })
    await StudentApi.postCertificate(Number(id), body)
      .then((res) => {
        if (res.status < 300) {
          alertSuccess("บันทึก", "บันทึก เรียบร้อย");
          getDetail()
        }
      })
      .catch((err) => {
        console.log(err);
        alertError("บันทึก", "บันทึก ไม่สำเร็จ");
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  }
  function formatBytes(bytes: any, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }
  console.log(detail);
  const deleteFile = async (id_student_certificate: any, id_student_certificate_file: any) => {
    await StudentApi.deleteCertificateFile(Number(id), Number(id_student_certificate_file))
      .then((res) => {
        if (res.status < 300) {
          alertSuccess("ลบไฟล์", "ลบไฟล์ เรียบร้อย");
          setDetail((prev: any) =>
            prev.map((item: any, indexItem: number) =>
              item?.id_student_certificate === id_student_certificate
                ? {
                  ...item,
                  student_certificate_file: {}
                }
                : item
            )
          );
          // getDetail()
        }
      })
      .catch((err) => {
        console.log(err);
        alertError("ลบไฟล์", "ลบไฟล์ ไม่สำเร็จ");
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  }
  const deleteCertificate = async (id_student_certificate: any) => {
    await StudentApi.deleteCertificate(Number(id), Number(id_student_certificate))
      .then((res) => {
        if (res.status < 300) {
          alertSuccess("ลบช่องอัพโหลด", "ลบช่องอัพโหลด เรียบร้อย");
          setDetail(
            detail.filter((item: any) =>
              item?.id_student_certificate !== id_student_certificate
            )
          );
          // getDetail()
        }
      })
      .catch((err) => {
        console.log(err);
        alertError("ลบช่องอัพโหลด", "ลบช่องอัพโหลด ไม่สำเร็จ");
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  }
  return (
    <>
      <ContainerButton
        sxContainer={{ my: 3, display: 'flex', justifyContent: "start" }}
        buttonData={[

          {
            seq: 1,
            buttonProps: {
              onClick: () => {
                setShowModal('ADD')
              }
            },
            key: "ADD2",
            label: "เพิ่มช่องอัพโหลด",
            type: 'ADD2'
          },

        ]}
      />
      {detail?.map((item: any, index: number) => {
        return (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
              <Typography variant='h6'>{item?.certificate_name}</Typography>
              <Bag onClick={() => {
                alertActive("ลบช่องอัพโหลด", "ต้องการลบช่องอัพโหลด ? ", undefined, undefined, async () => {
                  if (item?.id_student_certificate) {
                    deleteCertificate(item?.id_student_certificate)
                  } else {
                    setDetail(
                      detail.filter((_: any, i: number) =>
                        i !== index
                      )
                    );
                  }
                })
              }} />

            </div>
            {item?.student_certificate_file &&
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

                {item?.student_certificate_file?.file_name ?
                  <div style={{
                    border: "2px dotted #C1C3C7",
                    borderRadius: "10px",
                    padding: "15px 15px",
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                  }}>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <Document />
                      <div style={{ display: "flex", alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.student_certificate_file?.file_name}</Typography>
                        {/* <Typography sx={{ fontSize: '14px', }} >ขนาดไม่เกิน 10MB</Typography> */}
                      </div>
                    </div>

                    <ButtonOutlined
                      onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        window.open(pathUrl + '/' + item?.student_certificate_file?.file_path + item?.student_certificate_file?.file_name, '_blank');
                      }}
                      buttonName={'ดาวน์โหลดไฟล์'}
                      btnProps={{
                        width: "150px",
                        // border: '#0F9F0C'
                      }}
                    />
                  </div> :
                  <UploadFile
                    onDrop={(file) => {
                      // handleUpdate('contents', file, index);
                      onImageChange(file, index)
                    }}
                    // enableFormatImage
                    onDeleteFile={() => {
                      // setFile(null);
                    }}
                    noClick={false}
                  // formatText='ขนาดไม่เกิน 10MB'
                  // customFormat={["image/jpeg", "image/jpg", "image/png"]}

                  />}
                {item?.student_certificate_file?.id_student_certificate_file &&
                  <div style={{
                    border: '1px solid #DDE1EB',
                    borderRadius: '8px',
                    padding: '16px',
                    cursor: 'pointer'
                  }} onClick={() => {
                    alertActive("ลบไฟล์", "ต้องการลบไฟล์ ? ", undefined, undefined, async () => {
                      if (item?.id_student_certificate) {
                        deleteFile(item?.id_student_certificate, item?.student_certificate_file?.id_student_certificate_file)

                      } else {
                        setDetail((prev: any) =>
                          prev.map((item: any, indexItem: number) =>
                            index === indexItem
                              ? {
                                ...item,
                                student_certificate_file: {}
                              }
                              : item
                          )
                        );
                      }
                    })
                  }}>
                    <Bag />
                  </div>}
              </div>

            }
          </>
        )
      })}

      <ContainerButton
        sxContainer={{ my: 3 }}
        buttonData={[
          // {
          //   seq: 1,
          //   buttonProps: {
          //     onClick: () => { },
          //   },
          //   key: "CANCEL",
          //   label: "ย้อนกลับ",
          //   type: "CANCEL"
          // },
          {
            seq: 2,
            // hidden: tabStep !== 4,
            buttonProps: {
              onClick: () => { handleSubmit() },
            },
            key: "SAVE",
            label: "บันทึก",
            type: "SAVE"
          },


        ]}
      />
      {showModal === 'ADD' && (
        <ModalCustom
          open
          title={'เพิ่มช่องอัพโหลด'}
          subTitle={"กรุณาระบุหมายเหตุ"}
          // maxWidth={600}
          onClose={handleCloseModal}
          containerButton={{
            disabled_submit: !name,
            // hidden_submit: showModal === 'VIEW',
            onClose: handleCloseModal,
            onSubmit: () => {
              setDetail([...detail, {
                certificate_name: name, student_certificate_file: {}, status: "active"
              }])
              handleCloseModal()
            }
          }}
          component={
            <div className='w-full'>
              <StateComponents
                otherProps={{ spacing: 2 }}
                typeProps={[


                  {
                    seq: 1,
                    type: "TEXT_FIELD",
                    gridProps: {
                      xs: 12,
                      // md: 6
                    },
                    fieldProps: {
                      heading: "ชื่อช่องอัพโหลด",
                      onChange: (e) => {
                        setName(e.target.value)
                      },
                      value: name || '',
                      // minRow: 6,
                      // multiline: true,
                      // inputHeight: 'auto'
                    }
                  },
                ]} />
            </div>
          }
        />
      )}
    </>
  )
}
const EducationalRecord = (props: any) => {
  const { form } = props
  const { t } = useTranslation();
  const theme = useTheme()
  const { id } = useParams()
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const navigate: NavigateFunction = useNavigate();
  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("modified_date");
  const [sortType, setSortType] = useState<string>("DESC")
  const [keyword, setKeyword] = useState<string>("");
  const [data, setData] = useState<any[]>([]);
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy)
    setSortType(sortType)
  }

  const headCells = [
    {
      id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'left', label: t("ชั้นปีที่")
    },
    {
      id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'center', label: t("ปีการศึกษา")
    },
    {
      id: "subject_name", disablePadding: false, width: 300, align: "center", label: t("เทอม")
    },

    {
      id: "detail", disablePadding: false, align: "center", width: 300, label: t("GPA")
    },
    {
      id: "detail", disablePadding: false, align: "center", width: 200, label: t("สถานะนักศึกษา")
    },

    {
      id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 120, class: matches && data.length > 0, label: ""
    },
  ];
  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1
    const {
      academic_year,
      term,
      gpa,
      semester,
      educational_status,
      id_student_educational
    } = objData;
    const objRenderData = {
      key: no,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "left",
          label: semester || "-",
        },

        {
          option: "TEXT",
          align: "center",
          label: academic_year || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: term || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: gpa || "-",
        },
        {
          option: "COMPONENT",
          align: "center",
          component: <StatusCustom
            disableMaxWidth
            text={renderStatus(educational_status)}
            type={renderStatus(educational_status)}
          />,
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches && data.length > 0,
          component: <div className='flex justify-center items-center'>
            {/* <IconButton onClick={() => navigate(routeName.admission.applicants_detail)}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
            <OptionsButtonCustom
              enableEdit
              enableView
              // enableDelete
              onViewClick={() => navigate(routeName.admission.student_registration_information_education_view.replace(':id', `${id}`).replace(':id_student_educational', `${id_student_educational}`), {
                state: {
                  form,
                  objData
                }
              })}
              onEditClick={() => navigate(routeName.admission.student_registration_information_education.replace(':id', `${id}`).replace(':id_student_educational', `${id_student_educational}`), {
                state: {
                  form,
                  objData
                }
              })}
            // onDeleteClick={() => handleDeleteList(id_comment)}
            />
          </div>
        },
      ],
    };
    return <TableRowCommon
      {...objRenderData}
    />;
  };
  const handleGetData = useCallback(async () => {
    let query: any = {
      page: page,
      limit: pageLimit,

    };


    await StudentApi.getEducation(Number(id), query).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setTotalItems(res.data?.data?.meta?.totalItems || 0);
        setData(data.data.items);
      } else {
        setData([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [page, pageLimit])


  useEffect(() => {
    handleGetData()
  }, [handleGetData])


  return (
    <>
      <div className='w-full'>
        <section className='w-full mt-4'>
          <TableCustom
            tableMinWidth={1440}
            tableFixedWidth
            customScroll
            page={page}
            pageLimit={pageLimit}
            sortBy={sortBy}
            sortType={sortType}
            headCells={headCells}
            rowCount={totalItems}
            rowsData={data?.map((data: any, i: any) => {
              return renderData(data, i)
            })}
            onSort={handleRequestSort}
            setPageLimit={(value: number) => setPageLimit(value)}
            setPage={(value: number) => setPage(value)}
          />
        </section>
      </div>
    </>
  )
}
const VisaInformation = () => {
  const { t } = useTranslation();
  const theme = useTheme()
  const { id } = useParams()

  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const navigate: NavigateFunction = useNavigate();
  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("modified_date");
  const [sortType, setSortType] = useState<string>("DESC")
  const [keyword, setKeyword] = useState<string>("");
  const [data, setData] = useState<any[]>([]);
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy)
    setSortType(sortType)
  }

  const headCells = [
    {
      id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'left', label: t("ชื่อ - นามสกุล")
    },
    {
      id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'left', label: t("หมายเลขหนังสือเดินทาง")
    },
    {
      id: "subject_name", disablePadding: false, width: 300, align: "center", label: t("ประเภทวีซ่า")
    },

    {
      id: "detail", disablePadding: false, align: "center", width: 300, label: t("วันที่ออกวีซ่า")
    },
    {
      id: "detail", disablePadding: false, align: "center", width: 300, label: t("วันที่วีซ่าหมดอายุ")
    },
    {
      id: "detail", disablePadding: false, align: "center", width: 300, label: t("สถานะ")
    },

  ];
  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1
    const {
      visa_form_name,
      create_name,
      idcard,
      title,
      student_frist_name,
      student_last_name,
      exp_date,
      issue_date,
      status_visa

    } =
      objData;
    const objRenderData = {
      key: no,
      id: no,
      obj: objData,
      columns: [
        { option: "TEXT", align: "left", label: `${title} ${student_frist_name} ${student_last_name}` || "-" },
        {
          option: "TEXT",
          align: "left",
          label: idcard || "-",
        },

        {
          option: "TEXT",
          align: "center",
          label: visa_form_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: issue_date ? dateToView(issue_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: exp_date ? dateToView(exp_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: status_visa || "-",
        },



      ],
    };
    return <TableRowCommon
      {...objRenderData}
    />;
  };
  const handleGetData = useCallback(async () => {
    let query: any = {
      page: page,
      limit: pageLimit,

    };


    await StudentApi.fetchGetVisa(Number(id), query).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setTotalItems(res.data?.data?.meta?.totalItems || 0);
        setData(data.data.items);
      } else {
        setData([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [page, pageLimit])


  useEffect(() => {
    handleGetData()
  }, [handleGetData])
  return (
    <>
      <div className='w-full'>
        <section className='w-full mt-4'>
          <TableCustom
            tableMinWidth={1440}
            tableFixedWidth
            customScroll
            page={page}
            pageLimit={pageLimit}
            sortBy={sortBy}
            sortType={sortType}
            headCells={headCells}
            rowCount={totalItems}
            rowsData={data?.map((data: any, i: any) => {
              return renderData(data, i)
            })}
            onSort={handleRequestSort}
            setPageLimit={(value: number) => setPageLimit(value)}
            setPage={(value: number) => setPage(value)}
          />
        </section>
      </div>
    </>
  )
}

const TermFees = () => {
  const { t } = useTranslation();
  const { id } = useParams()

  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const navigate: NavigateFunction = useNavigate();
  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("modified_date");
  const [sortType, setSortType] = useState<string>("DESC")
  const [keyword, setKeyword] = useState<string>("");
  const [data, setData] = useState<any[]>([{}]);
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy)
    setSortType(sortType)
  }
  const [pathUrl, setPathUrl] = useState<string>("");

  const getDetail = async (id_student_term_payment: number) => {
    await StudentApi.get_student_term_payment_detail(Number(id), Number(id_student_term_payment)).then((res) => {
      if (res.status < 300) {
        // setDeatil(res.data?.data);
        window.open(pathUrl + '/' + res.data?.data?.file_path + res.data?.data?.file_name, '_blank')
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  const headCells = [
    {
      id: "id_comment", width: 200, sortable: false, disablePadding: false, align: 'left', label: t("ปีการศึกษา")
    },
    {
      id: "id_comment", width: 200, sortable: false, disablePadding: false, align: 'center', label: t("ภาคเรียนที่")
    },
    {
      id: "subject_name", disablePadding: false, width: 200, align: "center", label: t("วันที่ชำระเงิน")
    },

    {
      id: "detail", disablePadding: false, align: "center", width: 200, label: t("เวลาชำระเงิน")
    },
    {
      id: "detail", disablePadding: false, align: "center", width: 200, label: t("สกุลเงิน")
    },
    {
      id: "detail", disablePadding: false, align: "center", width: 300, label: t("จำนวนยอดเงิน")
    },
    {
      id: "detail", disablePadding: false, align: "center", width: 300, label: t("ผู้ตรวจสอบ")
    },
    {
      id: "detail", disablePadding: false, align: "center", width: 300, label: t("วันที่ตรวจสอบ")
    },
    {
      id: "detail", disablePadding: false, align: "center", width: 300, label: t("สถานะ")
    },

    {
      id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 120, class: matches && data.length > 0, label: ""
    },
  ];
  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1
    const {
      year,
      payment_currency,
      term,
      payment_date,
      inspection_name,
      inspection_date,
      id_student_term_payment,
      payment_amount,
      status

    } =
      objData;
    const objRenderData = {
      key: no,
      id: no,
      obj: objData,
      columns: [
        { option: "TEXT", align: "left", label: year || "-" },
        {
          option: "TEXT",
          align: "center",
          label: term || "-",
        },

        {
          option: "TEXT",
          align: "center",
          label: payment_date ? dateToView(payment_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: payment_date ? timeToView(payment_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: payment_currency || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: payment_amount || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: inspection_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: inspection_date ? dateToView(inspection_date) : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: status || "-",
        },


        {
          option: "COMPONENT",
          align: "center",
          class: matches && data.length > 0,
          component: <div className='flex justify-center items-center'>
            {/* <IconButton onClick={() => navigate(routeName.admission.applicants_detail)}>
                            <ArrowForwardIosIcon />
                        </IconButton> */}
            <OptionsButtonCustom
              enableDownload
              enableView
              // enableDelete
              onViewClick={() => navigate(routeName.admission.student_registration_information_term_fees.replace(':id', `${id}`).replace(':id_student_term_payment', `${id_student_term_payment}`))}
            // onEditClick={() => handleGetOneDetail(id_comment, 'EDIT')}
            // onDeleteClick={() => handleDeleteList(id_comment)}
            onDownloadClick={() => getDetail(id_student_term_payment)}
            />
          </div>
        },
      ],
    };
    return <TableRowCommon
      {...objRenderData}
    />;
  };
  const handleGetData = useCallback(async () => {
    let query: any = {
      page: page,
      limit: pageLimit,

    };


    await StudentApi.get_student_term_payment(Number(id), query).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setTotalItems(res.data?.data?.meta?.totalItems || 0);
        setData(data.data.items);
      } else {
        setData([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [page, pageLimit])


  useEffect(() => {
    handleGetData()
  }, [handleGetData])

 useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);

  return (
    <>
      <div className='w-full'>
        <section className='w-full mt-4'>
          <TableCustom
            tableMinWidth={1440}
            tableFixedWidth
            customScroll
            page={page}
            pageLimit={pageLimit}
            sortBy={sortBy}
            sortType={sortType}
            headCells={headCells}
            rowCount={totalItems}
            rowsData={data?.map((data: any, i: any) => {
              return renderData(data, i)
            })}
            onSort={handleRequestSort}
            setPageLimit={(value: number) => setPageLimit(value)}
            setPage={(value: number) => setPage(value)}
          />
        </section>
      </div>
    </>
  )
}